export const GET_ADMIN_USERS = "getAdminUsers";

// Platform Terms & Conditions
export const ADD_PLATFORM_TERMS_CONSENT = "addPlatformTermsConsent";

// Sign Up Flow Random Trash
export const GET_REFERRER = "getReferrer";

// Digital Agronomist
export const ADD_OR_UPDATE_DIGITAL_AGRONOMIST_PREFERENCES = "addOrUpdateDigitalAgronomistPreferences";
export const UPDATE_DIGITAL_AGRONOMIST_PREFERENCES = "updateDigitalAgronomistPreferences";
export const GET_DIGITAL_AGRONOMIST_PREFERENCES = "getDigitalAgronomistPreferences";
export const GET_FARM_RESILIENCE_SCORE = "getFarmResilienceScore";
export const GET_SCENARIO_RESILIENCE_SCORE = "getScenarioResilienceScore";
export const GET_SCENARIO_RESILIENCE_INSIGHT = "getScenarioResilienceInsight";

// Crop Mix Composer
export const CALCULATE_COVER_CROP_MIXES = "calculateCoverCropMixes";
export const GET_CROP_MIX_COMPOSER_SCORE_FACTORS = "getCropMixComposerScoreFactors";
export const GET_CROP_MIX_COMPOSER_SETTINGS = "getCropMixComposerSettings";
export const DELETE_CROP_MIX_COMPOSER_SETTINGS = "deleteCropMixComposerSettings";
export const GET_CROP_MIX_COMPOSER_CROPS = "getCropMixComposerCrops";
export const ADD_CROP_MIX_COMPOSER_CROPS = "addCropMixComposerCrops";
export const MUTATE_CROP_MIX_COMPOSER_SETTINGS = "mutateCropMixComposerSettings";
export const CALCULATE_CROP_MIX_POTENTIAL_PAYOUT = "calculateCropMixPotentialPayout";
export const GET_CROP_MIX_COMPOSER_COMMERCIAL_MIXES = "getCropMixComposerCommercialMixes";
export const EXPORT_CROP_MIX_COMPOSER_COMMERCIAL_MIXES = "exportCropMixComposerCommercialMixes";
export const UPDATE_CROP_MIX_COMPOSER_COMMERCIAL_MIXES = "updateCropMixComposerCommercialMixes";

// Farms & Farm details
export const GET_FARMS = "getFarms";
export const ADD_FARM = "addFarm";
export const DELETE_FARM = "deleteFarm";
export const GET_FARM_DETAILS = "getFarmDetails";
export const UPDATE_FARM_DETAILS = "updateFarmDetails";
export const GET_ALL_USER_VERIFICATION_FARM_TASKS = "getAllUserVerificationFarmTasks";
export const GET_FARM_FEATURE_FLAGS = "getFarmFeatureFlags";
export const ADD_OR_UPDATE_FARM_FEATURE_FLAG = "addOrUpdateFarmFeatureFlag";
export const GET_FARM_SETTINGS = "getFarmSettings";
export const UPDATE_FARM_SETTING = "updateFarmSetting";

// Payouts
export const GET_FARM_PAYMENTS = "getFarmPayments";
export const GET_FARM_PAYMENT_ITEMS = "getFarmPaymentItems";

// Farm Admin
export const GET_FARM_AREA_SUMMARY = "getFarmAreaSummary";
export const GET_FARM_VERIFICATIONS = "getFarmVerifications";
export const UPDATE_FARM_CREDIT_ALLOTMENTS = "updateFarmCreditAllotments";
export const TOGGLE_FARM_FOOTPRINTING = "toggleFarmFootprinting";

// Fields
export const GET_FIELDS = "getFieldList";
export const GET_FARM_FIELD_LIST_AT_POINT_IN_TIME = "getFarmFieldListAtPointInTime";
export const SPLIT_FIELD = "splitField";
export const GET_FIELDS_ADMIN = "getFieldsAdmin";
export const GET_FIELDS_BASIC_DETAILS = "getFieldBasicDetails";
export const DELETE_FIELD = "deleteField";
export const DELETE_MULTIPLE_FIELDS = "deleteMultipleFields";
export const GET_FIELD_DETAILS = "getFieldDetails";
export const GET_FIELD_PRACTICES = "getFieldPractices";
export const GET_FIELD_PRACTICE_TIMESTAMPS = "getFieldPracticeTimestamps";
export const ADD_FIELD_PRACTICE_PARTICIPATIONS = "addFieldPracticeParticipations";
export const DELETE_FIELD_PRACTICE_PARTICIPATIONS = "deleteFieldPracticeParticipations";
export const CANCEL_FIELD_REACTIVATION = "cancelFieldReactivation";
export const GET_FIELDS_CROP_RECOMMENDATIONS = "getFieldCropRecommendations";
export const UPDATE_FIELD = "updateField";
export const ADD_FIELD = "addField";
export const ADD_SOC_SAMPLE = "addSocSample";
export const GET_SOC_SAMPLES = "getSocSamples";
export const GET_FIELD_EVALUATION_METRIC_CORRECTIONS = "getFieldEvaluationMetricCorrections";
export const MUTATE_FIELD_EVALUATION_METRIC_CORRECTION = "mutateFieldEvaluationMetricCorrection";
export const DELETE_FIELD_EVALUATION_METRIC_CORRECTION = "deleteFieldEvaluationMetricCorrection";
export const GET_FIELD_SIZE_UPDATES = "getFieldSizeUpdates";
export const CONFIRM_FIELD_REDZONE_ADMIN = "confirmFieldRedzoneAdmin";
export const VERIFY_FIELD = "verifyField";
export const GET_FIELD_VERIFICATIONS = "getFieldVerifications";
export const GET_FIELD_TASKS = "getFieldTasks";
export const GET_REDZONE_EXCEPTIONS = "getRedzoneExceptions";
export const GET_PENDING_COVER_CROP_DETECTIONS = "getPendingCoverCropDetections";
export const GET_FARM_COVER_CROP_DETECTIONS = "getFarmCoverCropDetections";
export const GET_FARM_MAIN_CROP_DETECTIONS = "getFarmMainCropDetections";
export const GET_FIELD_SATELLITE_OBSERVATIONS = "getFieldSatelliteObservations";
export const GET_FIELD_SATELLITE_THUMBNAILS = "getFieldSatelliteThumbnails";
export const GET_FIELD_SATELLITE_IMAGE = "getFieldSatelliteImage";
export const DECIDE_COVER_CROP_DETECTIONS = "decideCoverCropDetections";
export const DECIDE_FARM_DETECTION = "decideFarmDetection";
export const GET_FIELD_REDZONES = "getFieldRedzones";

// Modules
export const GET_MODULES = "getModules";

// crops
export const ADD_FIELD_CROP_PRACTICE = "addFieldCropPractice";
export const UPDATE_FIELD_CROP_PRACTICE = "updateFieldCropPractice";
export const DELETE_FIELD_CROP_PRACTICE = "deleteFieldCropPractice";

// Bulk action on crops
export const UPDATE_BULK_FIELD_CROP_PRACTICE = "updateBulkFieldCropPractice";
export const UPDATE_BULK_CROP_YIELD = "updateBulkCropYield";
export const UPDATE_BULK_CROP_SEEDING = "updateBulkCropSeeding";
export const UPDATE_BULK_CROP_ORGANIC_FERTILIZER = "updateBulkOrganicFertilizer";
export const UPDATE_BULK_CROP_MINERAL_FERTILIZER = "updateBulkMineralFertilizer";
export const UPDATE_BULK_CROP_TILLAGE = "updateBulkTillage";
export const UPDATE_BULK_CROP_DATES = "updateBulkCropDates";

// verfications
export const VERIFY_FIELDS = "verifyFields";
export const UPDATE_FARM_VERIFICATION_SIZE = "updateFarmVerificationSize";
export const UPDATE_FIELD_VERIFICATION_SIZE = "updateFieldVerificationSize";
export const UPDATE_FIELD_VERIFICATION_OFFICIAL_SIZE = "updateFieldVerificationOfficialSize";
export const ADD_VERIFICATION_RECALCULATION_TRIGGER = "addVerificationRecalculationTrigger";
export const GET_VERIFICATION_RECALCULATION_TRIGGER = "getVerificationRecalculationTrigger";
export const GET_LATEST_VERIFICATION_RECALCULATION_TRIGGER = "getLatestVerificationRecalculationTrigger";
export const FARM_VERIFICATION_SUMMARY = "farm-verification-summary";
export const FIELD_VERIFICATION_SUMMARY = "field-verification-summary";
export const ADMIN_FIELD_VERIFICATIONS = "admin-field-verifications";
export const UPLOAD_VERIFICATION_STATUS = "uploadVerificationStatus";
export const GET_VERIFICATION_STATUS_UPLOADS = "getVerificationStatusUploads";
export const FARM_PAYOUT_APPROVALS = "farm-payout-approvals";
export const FARM_PAYOUT_APPROVALS_ADMIN = "farm-payout-approvals-admin";

// Certifications
export const GET_CERTIFICATIONS = "getCertifications";
export const GET_PROGRAM_VERIFICATION_POINTS = "getProgramVerificationPoints";

// Carbon programs
export const GET_CARBON_PROGRAM_OUTCOMES = "getCarbonProgramOutcomes";
export const GET_CARBON_PROGRAM_BY_ID = "getCarbonProgramById";
export const GET_CARBON_PROGRAM_OUTCOMES_ADMIN = "getCarbonProgramOutcomesAdmin";
export const GET_CARBON_PROGRAM_BY_FARM_ID = "getCarbonProgramByFarmId";
export const GET_CARBON_PROGRAM_BY_FARM_ID_ADMIN = "getCarbonProgramByFarmIdAdmin";
export const GET_ALL_CARBON_PROGRAMS = "getAllCarbonPrograms";
export const ADD_FARM_TO_CARBON_PROGRAM = "addFarmToCarbonProgram";
export const GET_FARMS_BY_CARBON_PROGRAM = "getFarmsByCarbonProgram";
export const GET_INCENTIVES_POTENTIAL_PAYOUTS = "getIncentivesPotentialPayouts";
export const ADD_PROGRAM_TERMS_CONSENT = "addProgramTermsConsent";
export const GET_PROGRAM_CONTRACT = "getProgramContract";
export const GET_PROGRAM_CONTRACTS_ADMIN = "getProgramContractsAdmin";
export const GET_CARBON_PROGRAM_FEATURE_FLAGS = "getCarbonProgramFeatureFlags";
export const ADD_OR_UPDATE_CARBON_PROGRAM_FEATURE_FLAG = "addOrUpdateCarbonProgramFeatureFlag";
export const GET_LATEST_PROGRAM_CONTRACTS = "getLatestProgramContracts";
export const GET_INCENTIVES_POTENTIAL_PAYOUTS_ADMIN = "getIncentivesPotentialPayoutsAdmin";

// Partners
export const GET_ALL_PARTNERS = "getAllPartners";
export const GET_PARTNER = "getPartner";
export const UPDATE_PARTNER = "updatePartner";

// Practices
export const GET_PRACTICES_CROPS = "getPracticesCrops";
export const GET_PRACTICES_FERTILIZERS_MINERAL = "getPracticesFertilizersMineral";
export const GET_PRACTICES_FERTILIZERS_ORGANIC = "getPracticesFertilizersOrganic";
export const GET_PRACTICES_FERTILIZERS_APPLICATIONS = "getPracticesFertilizersApplications";
export const GET_PRACTICES_PLANT_PPROTECTION = "getPracticesPlantProtections";
export const GET_PRACTICES_TILLAGES = "getPracticesTillages";
export const GET_PRACTICES_SEEDINGS = "getPracticesSeedings";
export const GET_PRACTICES = "getPractices";

// Field filters by practice
export const GET_FIELD_PRACTICE_FILTER_OPTIONS = "getFieldPracticeFilterOptions";
export const GET_PRACTICE_FILTERED_FIELD_IDS = "getPracticeFilteredFieldIds";

// Footprinting
export const FOOTPRINTING_FARM = "footprintingFarm";
export const FOOTPRINTING_FARM_CALCULATED_FOOTPRINT = "footprintingFarmCalculatedFootprint";
export const FOOTPRINTING_FARM_PRIMARY_DATA = "footprintingFarmPrimaryData";
export const FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN = "footprintingFarmPrimaryDataAdmin";
export const FOOTPRINTING_FARM_RESOURCE_CONSUMPTION = "footprintingFarmResourceConsumption";
export const FOOTPRINTING_EMISSION_FACTORS_REFRIGERANTS = "footprintingEmissionFactorsRefrigerants";
export const FOOTPRINTING_DAIRY_REFRIGERANT_USAGE = "footprintingDairyRefrigerantUsage";
export const FOOTPRINTING_LAND_USE_CHANGES = "footprintingLandUseChanges";
export const FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE = "footprintingFarmLandUseChanges";
export const FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE_ADMIN = "footprintingFarmLandUseChangesAdmin";
export const FOOTPRINTING_FARM_CROP_PLANT_PROTECTION = "footprintingCropPlantProtectionByPrimaryDataId";

// Soil Sight validation
export const RUN_SOIL_SIGHT_VERSION_VALIDATION = "runSoilSightVersionValidation";
export const GET_VALIDATION_RUN = "getValidationRun";
export const LIST_SILVER_VERSIONS = "listSilverVersions";
export const LIST_VERSION_REVIEWS = "listVersionReviews";
export const LIST_PUBLIC_SILVER_VERSIONS = "listPublicSilverVersions";

export const FOOTPRINTING_CROP = "footprintingCrop";
export const FOOTPRINTING_CROP_CALCULATED_FOOTPRINT = "footprintingCropCalculatedFootprint";
export const FOOTPRINTING_CROP_PRIMARY_DATA = "footprintingCropPrimaryData";
export const FOOTPRINTING_CROP_PRIMARY_DATA_ADMIN = "footprintingCropPrimaryDataAdmin";
export const FOOTPRINTING_CROP_DRYINGS = "footprintingCropDryings";
export const FOOTPRINTING_CROP_SEEDINGS = "footprintingCropSeedings";
export const FOOTPRINTING_CROP_TILLAGES = "footprintingCropTillages";
export const FOOTPRINTING_CROP_SALES = "footprintingCropSales";
export const FOOTPRINTING_CROP_PURCHASERS = "footprintingCropPurchasers";
export const FOOTPRINTING_CROP_FERTILIZERS_MINERAL = "footprintingCropFertilizersMineral";
export const FOOTPRINTING_CROP_FERTILIZERS_ORGANIC = "footprintingCropFertilizersOrganic";
export const FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW = "footprintingCropAssessmentsRequiringReview";

export const FOOTPRINTING_DAIRY = "footprintingDairy";
export const FOOTPRINTING_DAIRY_CALCULATED_FOOTPRINT = "footprintingDairyCalculatedFootprint";
export const FOOTPRINTING_DAIRY_PRIMARY_DATA = "footprintingDairyPrimaryData";
export const FOOTPRINTING_DAIRY_FEED_ADDITIVE = "footprintingDairyFeedAdditive";
export const FOOTPRINTING_DAIRY_GRASSLAND_FERTILISER = "footprintingDairyGrasslandFertiliser";
export const FOOTPRINTING_DAIRY_MANURE_STORAGE = "footprintingDairyManureStorage";
export const FOOTPRINTING_DAIRY_MANURE_ADDITIVE = "footprintingDairyManureAdditive";
export const FOOTPRINTING_DAIRY_FEED_PRODUCTION = "footprintingDairyFeedProduction";
export const FOOTPRINTING_DAIRY_FEED_INFORMATION = "footprintingDairyFeedInformation";
export const FOOTPRINTING_DAIRY_HERD_DETAILS = "footprintingDairyHerdDetails";
export const FOOTPRINTING_DAIRY_HERD_SIZE = "footprintingDairyHerdSize";
export const FOOTPRINTING_DAIRY_COWS_SOLD = "footprintingDairyCowsSold";

// Dairy reference tables
export const GET_DAIRY_COW_TYPES = "getDairyCowTypes";
export const GET_DAIRY_FEED_TYPES = "getDairyFeedTypes";
export const GET_DAIRY_FEED_ADDITIVES = "getDairyFeedAdditives";
export const GET_DAIRY_MANURE_STORAGE = "getDairyManureStorage";

// Shared across every animal type — one endpoint, one catalog table
export const GET_MANURE_ADDITIVES = "getManureAdditives";

// PORK
export const FOOTPRINTING_PORK = "footprintingPork";
export const FOOTPRINTING_PORK_PRIMARY_DATA = "footprintingPorkPrimaryData";
export const FOOTPRINTING_PORK_CALCULATED_FOOTPRINT = "footprintingPorkCalculatedFootprint";
export const FOOTPRINTING_PORK_FEED_INFORMATION = "footprintingPorkFeedInformation";
export const FOOTPRINTING_PORK_FEED_PRODUCTION = "footprintingPorkFeedProduction";
export const FOOTPRINTING_PORK_HERD_DETAILS = "footprintingPorkHerdDetails";
export const FOOTPRINTING_PORK_MANURE_ADDITIVE = "footprintingPorkManureAdditive";
export const FOOTPRINTING_PORK_MANURE_STORAGE = "footprintingPorkManureStorage";
export const FOOTPRINTING_PORK_PIGLET_SOURCING = "footprintingPorkPigletSourcing";
export const FOOTPRINTING_PORK_STABLES = "footprintingPorkStables";
export const GET_PORK_SOURCE_FARMS = "getPorkSourceFarms";

// Pork reference tables
export const GET_PORK_FEED_TYPES = "getPorkFeedTypes";
export const GET_PORK_MANURE_STORAGE = "getPorkManureStorage";

// PIGLET
export const FOOTPRINTING_PIGLET = "footprintingPiglet";
export const FOOTPRINTING_PIGLET_PRIMARY_DATA = "footprintingPigletPrimaryData";
export const FOOTPRINTING_PIGLET_CALCULATED_FOOTPRINT = "footprintingPigletCalculatedFootprint";
export const FOOTPRINTING_PIGLET_FEED_INFORMATION = "footprintingPigletFeedInformation";
export const FOOTPRINTING_PIGLET_FEED_PRODUCTION = "footprintingPigletFeedProduction";
export const FOOTPRINTING_PIGLET_HERD_DETAILS = "footprintingPigletHerdDetails";
export const FOOTPRINTING_PIGLET_MANURE_ADDITIVE = "footprintingPigletManureAdditive";
export const FOOTPRINTING_PIGLET_MANURE_STORAGE = "footprintingPigletManureStorage";
export const FOOTPRINTING_PIGLET_STABLES = "footprintingPigletStables";

// Piglet reference tables
export const GET_PIGLET_FEED_TYPES = "getPigletFeedTypes";
export const GET_PIGLET_MANURE_STORAGE = "getPigletManureStorage";

// BEEF
export const FOOTPRINTING_BEEF = "footprintingBeef";
export const FOOTPRINTING_BEEF_CALCULATED_FOOTPRINT = "footprintingBeefCalculatedFootprint";
export const FOOTPRINTING_BEEF_PRIMARY_DATA = "footprintingBeefPrimaryData";
export const FOOTPRINTING_BEEF_HERD_SIZE = "footprintingBeefHerdSize";
export const FOOTPRINTING_BEEF_HERD_DETAILS = "footprintingBeefHerdDetails";
export const FOOTPRINTING_BEEF_FEED_ADDITIVE = "footprintingBeefFeedAdditive";
export const FOOTPRINTING_BEEF_FEED_INFORMATION = "footprintingBeefFeedInformation";
export const FOOTPRINTING_BEEF_FEED_PRODUCTION = "footprintingBeefFeedProduction";
export const FOOTPRINTING_BEEF_MANURE_STORAGE = "footprintingBeefManureStorage";
export const FOOTPRINTING_BEEF_MANURE_ADDITIVE = "footprintingBeefManureAdditive";
export const FOOTPRINTING_BEEF_GRASSLAND_FERTILISER = "footprintingBeefGrasslandFertiliser";

export const FOOTPRINTING_AUTOFILL_APPLIED = "footprintingAutofillApplied";

// Beef reference tables
export const GET_BEEF_COW_TYPES = "getBeefCowTypes";
export const GET_BEEF_FEED_TYPES = "getBeefFeedTypes";
export const GET_BEEF_FEED_ADDITIVES = "getBeefFeedAdditives";
export const GET_BEEF_MANURE_STORAGE_TYPES = "getBeefManureStorageTypes";

// platform-wide queries
export const GET_PLATFORM_CONTRACT = "getPlatformContract";
export const GET_PLATFORM_CONTRACTS_ADMIN = "getPlatformContractsAdmin";
export const GET_YEARLY_DATA_YEAR = "getYearlyDataYear";
export const GET_FULL_POPUP = "getFullPopup";
export const GET_REGIONS_BY_COUNTRY = "getRegionsByCountry";

// Admin experiments
export const GET_NDVI_SCORES = "getNdviScores";
export const GET_FLYOVERS = "getFlyovers";

// Admin change events
export const GET_FIELD_CHANGE_TIMELINE = "getFieldChangeTimeline";

// Field shapes
export const GET_FIELD_SHAPE_ADMIN = "getFieldShapeAdmin";
export const GET_FIELDS_SHAPE_ADMIN = "getFieldShapesAdmin";
export const GET_FIELD_VERIFICATION_SHAPE = "getFieldVerificationShape";
export const UPDATE_FIELD_SHAPE_AMDIN = "updateFieldShapeAdmin";
export const GET_FIELD_SHAPE = "getFieldShape";
export const GET_FIELD_SHAPES = "getFieldShapes";

// Admin Practices
export const EXPORT_DIGITAL_AGRONOMIST_CROP_PRACTICES = "exportDigitalAgronomistCropPractices";
export const UPDATE_DIGITAL_AGRONOMIST_CROP_PRACTICES = "updateDigitalAgronomistCropPractices";

// Admin Popup
export const GET_ALL_ADMIN_POPUPS = "getAllAdminPopups";
export const GET_ALL_ADMIN_POPUPS_BY_ID = "getAllAdminPopupsById";
export const UPDATE_ADMIN_POPUPS = "updateAdminPopups";

// Admin Settings
export const GET_ADMIN_SETTINGS = "getAdminSettings";
export const UPDATE_ADMIN_SETTINGS = "updateAdminSettings";
export const GET_ALL_FEATURE_FLAGS = "getAllFeatureFlags";
export const UPDATE_FEATURE_FLAG = "updateFeatureFlag";
export const GET_FEATBIT_SEGMENTS = "getFeatBitSegments";
export const GET_FEATBIT_SEGMENT_ENTRIES = "getFeatBitSegmentEntries";
export const SEARCH_FEATBIT_SEGMENT_ENTITIES = "searchFeatBitSegmentEntities";
export const APPLY_FEATBIT_SEGMENT_CHANGES = "applyFeatBitSegmentChanges";

// Editing requests
export const ADD_EDITING_REQUEST = "addEditingRequest";
export const UPDATE_EDITING_REQUEST = "updateEditingRequest";
export const GET_VERIFICATION_EDITING_REQUESTS = "getVerificationEditingRequests";
export const UPDATE_VERIFICATION_STATUS = "updateVerificationStatus";
export const UPDATE_REVIEWED_DATA_POINTS = "updateReviewedDataPoints";
export const UPDATE_VERIFICATION_EDITING_REQUEST = "updateVerificationEditingRequest";

// Data submission
export const ADD_FARM_DATA_SUBMISSION = "addFarmDataSubmission";
export const GET_FARM_DATA_SUBMISSION_STATUS = "getFarmDataSubmissionStatus";
export const GET_FARM_REPORTING_YEAR = "getFarmReportingYear";
export const GET_DATA_SUBMISSION_DATES = "getDataSubmissionDates";

// Data submission admin
export const UPDATE_FARM_DATA_SUBMISSION_ADMIN = "updateFarmDataSubmissionAdmin";

export const GET_CACHE_INVALIDATION = "getCacheInvalidation";

// Doc scans
export const GET_DOC_SCANS = "listFarmDocumentScans";
export const GET_DOC_SCAN = "getFarmDocumentScanById";

export const GET_DOC_SCAN_FIELDS = "listFarmDocumentScanFields";
export const PATCH_DOC_SCAN_FIELD = "patchFarmDocumentScanField";
export const GET_DOC_SCAN_STATISTICS = "getDocScanStatistics";
export const GET_FARM_DOC_SCAN_SUMMARY = "getFarmDocScanSummary";
export const GET_FARM_DOC_SCAN_FIELDS = "getFarmDocScanFields";
export const GET_FARM_DOC_SCAN_FIELD = "getFarmDocScanField";

// User doc scans
export const GET_USER_DOC_SCANS = "getUserDocScans";
export const CREATE_USER_DOC_SCAN = "createUserDocScan";

// Practice Management
export const PRACTICE_MANAGEMENT = "practiceManagement";
export const PRACTICE_MANAGEMENT_CROP_EMISSION_FACTORS = "cropEmissionFactors";
export const PRACTICE_MANAGEMENT_CROP_PARAMETERS = "cropParameters";
export const PRACTICE_MANAGEMENT_MINERAL_FERTILIZER_EMISSION_FACTORS = "mineralFertilizerEmissionFactors";
export const PRACTICE_MANAGEMENT_ORGANIC_FERTILIZER_EMISSION_FACTORS = "organicFertilizerEmissionFactors";
export const PRACTICE_MANAGEMENT_ORGANIC_FERTILIZER_PARAMETERS = "organicFertilizerParameters";
export const PRACTICE_MANAGEMENT_PLANT_PROTECTION_EMISSION_FACTORS = "plantProtectionEmissionFactors";
export const PRACTICE_MANAGEMENT_SEEDING_EMISSION_FACTORS = "seedingEmissionFactors";
export const PRACTICE_MANAGEMENT_SOIL_EMISSION_FACTORS = "soilEmissionFactors";
export const PRACTICE_MANAGEMENT_TILLAGE_EMISSION_FACTORS = "tillageEmissionFactors";
export const PRACTICE_MANAGEMENT_UTILITY_EMISSION_FACTORS = "utilityEmissionFactors";
export const PRACTICE_MANAGEMENT_PIGLET_PARAMETERS = "pigletParameters";
export const PRACTICE_MANAGEMENT_PORK_PARAMETERS = "porkParameters";
export const PRACTICE_MANAGEMENT_VERSIONS = "versions";
export const PRACTICE_MANAGEMENT_VERSION_INFO = "versionInfo";
export const PRACTICE_MANAGEMENT_VERSION_DIFFERENCES = "versionDifferences";
export const PRACTICE_MANAGEMENT_VERSION_NOTES = "versionNotes";

// Soil Sight
export const GET_SOIL_SIGHT_PROJECT = "getSoilSightProject";
export const GET_SOIL_SIGHT_FIELD_SOIL = "getSoilSightFieldSoil";
export const GET_SOIL_SIGHT_COVER_CROP_TIMING = "getSoilSightCoverCropTiming";
export const MUTATE_SOIL_SIGHT_OUTCOMES = "mutateSoilSightOutcomes";
export const MUTATE_SOIL_SIGHT_LINK_EMAIL = "mutateSoilSightLinkEmail";
export const MUTATE_ANONYMOUS_FORECAST = "mutateAnonymousForecast";
export const MUTATE_PREPARE_ANONYMOUS_FORECAST = "mutatePrepareAnonymousForecast";
export const GET_ANONYMOUS_FORECAST = "getAnonymousForecast";
export const CREATE_SOIL_SIGHT_PROJECT = "createSoilSightProject";
export const UPDATE_SOIL_SIGHT_PROJECT_SETTINGS = "updateSoilSightProjectSettingsRefinements";
export const LIST_SOIL_SIGHT_SCENARIOS = "listSoilSightScenarios";
export const GET_SOIL_SIGHT_SCENARIO = "getSoilSightScenario";
export const CREATE_SOIL_SIGHT_SCENARIO = "createSoilSightScenario";
export const UPDATE_SOIL_SIGHT_SCENARIO = "updateSoilSightScenario";
export const DELETE_SOIL_SIGHT_SCENARIO = "deleteSoilSightScenario";
export const REPLACE_SOIL_SIGHT_CROP_YEARS = "replaceSoilSightCropYears";
export const GET_SOIL_SIGHT_CROP_DATABASE = "getSoilSightCropDatabase";
export const GET_SOIL_SIGHT_NON_CROP_DATABASE = "getSoilSightNonCropDatabase";
export const GET_SOIL_SIGHT_CMC_RECOMMENDATION = "getSoilSightCmcRecommendation";
export const GENERATE_CMC_MIX_COPY = "generateCmcMixCopy";
export const LIST_SOIL_SIGHT_PROJECTS = "listSoilSightProjects";
export const RENAME_SOIL_SIGHT_PROJECT = "renameSoilSightProject";
export const DUPLICATE_SOIL_SIGHT_PROJECT = "duplicateSoilSightProject";

// Farm sources (livestock, organic fertilizer production, fodder-manure cooperations)
export const GET_FARM_LIVESTOCK = "getFarmLivestock";
export const CREATE_FARM_LIVESTOCK = "createFarmLivestock";
export const UPDATE_FARM_LIVESTOCK = "updateFarmLivestock";
export const DELETE_FARM_LIVESTOCK = "deleteFarmLivestock";
export const GET_FARM_ORGANIC_FERTILIZER_PRODUCTION = "getFarmOrganicFertilizerProduction";
export const CREATE_FARM_ORGANIC_FERTILIZER_PRODUCTION = "createFarmOrganicFertilizerProduction";
export const UPDATE_FARM_ORGANIC_FERTILIZER_PRODUCTION = "updateFarmOrganicFertilizerProduction";
export const DELETE_FARM_ORGANIC_FERTILIZER_PRODUCTION = "deleteFarmOrganicFertilizerProduction";
export const GET_FARM_FODDER_MANURE_COOPERATIONS = "getFarmFodderManureCooperations";
export const CREATE_FARM_FODDER_MANURE_COOPERATION = "createFarmFodderManureCooperation";
export const UPDATE_FARM_FODDER_MANURE_COOPERATION = "updateFarmFodderManureCooperation";
export const DELETE_FARM_FODDER_MANURE_COOPERATION = "deleteFarmFodderManureCooperation";
export const MUTATE_SOIL_SIGHT_DETAILED_ANALYSIS = "mutateSoilSightDetailedAnalysis";
export const GET_USER_SETTINGS = "getUserSettings";
export const UPDATE_USER_SETTING = "updateUserSetting";

// Admin organic fertilizer production
export const GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION = "getAdminFarmOrganicFertilizerProduction";

// Farm-independent query keys: preserved (not invalidated) on farm switch, since their data
// doesn't vary by farm. Approved scope per PE-754 — Dairy/Piglet/Beef reference tables,
// platform-wide queries, and Practices.
export const FARM_INDEPENDENT_QUERY_KEYS = [
  // Crop footprints: already scoped by farmId in their query keys, so they can stay cached across farm switches.
  FOOTPRINTING_CROP,
  // Dairy reference tables
  GET_DAIRY_COW_TYPES,
  GET_DAIRY_FEED_TYPES,
  GET_DAIRY_FEED_ADDITIVES,
  GET_DAIRY_MANURE_STORAGE,
  // Manure additives — shared catalog across every animal type
  GET_MANURE_ADDITIVES,
  // Piglet reference tables
  GET_PIGLET_FEED_TYPES,
  GET_PIGLET_MANURE_STORAGE,
  // Beef reference tables
  GET_BEEF_COW_TYPES,
  GET_BEEF_FEED_TYPES,
  GET_BEEF_FEED_ADDITIVES,
  GET_BEEF_MANURE_STORAGE_TYPES,
  // platform-wide queries
  GET_PLATFORM_CONTRACT,
  GET_PLATFORM_CONTRACTS_ADMIN,
  GET_YEARLY_DATA_YEAR,
  GET_FULL_POPUP,
  GET_REGIONS_BY_COUNTRY,
  // Practices
  GET_PRACTICES_CROPS,
  GET_PRACTICES_FERTILIZERS_MINERAL,
  GET_PRACTICES_FERTILIZERS_ORGANIC,
  GET_PRACTICES_FERTILIZERS_APPLICATIONS,
  GET_PRACTICES_PLANT_PPROTECTION,
  GET_PRACTICES_TILLAGES,
  GET_PRACTICES_SEEDINGS,
  GET_PRACTICES,
] as const;

export const ADMIN_SIGN_OUT_PRESERVED_QUERY_KEYS = [LIST_SILVER_VERSIONS, LIST_VERSION_REVIEWS, GET_VALIDATION_RUN] as const;
